import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { Gift, Calculator, PenTool, ShieldAlert, ListChecks, IceCream2 as IceCream, Camera, Megaphone } from 'lucide-react';
const bonuses = [{
  text: 'Calculadora de Rentabilidad (Excel)',
  icon: Calculator,
  color: 'text-palomitas-emerald'
}, {
  text: 'Pack de Diseño Marca Profesional',
  icon: PenTool,
  color: 'text-palomitas-pink'
}, {
  text: 'Guía Anti-Fracasos',
  icon: ShieldAlert,
  color: 'text-palomitas-coral'
}, {
  text: "Checklist 'Tu Negocio en 7 Días'",
  icon: ListChecks,
  color: 'text-palomitas-sky'
}, {
  text: 'Guía de Sabores Rentables',
  icon: IceCream,
  color: 'text-palomitas-purple'
}, {
  text: 'Kit de Fotos Profesionales',
  icon: Camera,
  color: 'text-palomitas-orange'
}, {
  text: 'Pack Estrategia de Ventas',
  icon: Megaphone,
  color: 'text-palomitas-coral'
}];
export function Content() {
  return <section className="py-20 bg-palomitas-dark text-white relative overflow-hidden" data-id="element-30">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0" data-id="element-31">
        <div className="absolute top-[-10%] right-[-10%] w-96 h-96 bg-palomitas-coral/10 rounded-full blur-3xl" data-id="element-32"></div>
        <div className="absolute bottom-[-10%] left-[-10%] w-96 h-96 bg-palomitas-purple/10 rounded-full blur-3xl" data-id="element-33"></div>
      </div>

      <div className="container px-4 mx-auto max-w-5xl relative z-10" data-id="element-34">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-35">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative" data-id="element-36">
            <img src="https://cdn.magicpatterns.com/uploads/5yEFGPhQxXDkpmW8HD3qpc/WhatsApp_Image_2026-04-30_at_02.12.11.jpg" alt="Bonos Exclusivos" className="w-full rounded-2xl shadow-2xl border-4 border-palomitas-gold/30" data-id="element-37" />
            <div className="absolute -bottom-4 -right-4 bg-palomitas-coral text-white font-bold py-3 px-6 rounded-full shadow-xl transform rotate-[-5deg] text-lg" data-id="element-38">
              🎁 ¡7 Bonos Gratis!
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-39">
            <span className="inline-block bg-palomitas-gold/20 text-palomitas-gold px-4 py-2 rounded-full font-bold text-sm uppercase tracking-wide mb-4" data-id="element-40">
              📦 Contenido
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-palomitas-beige mb-6" data-id="element-41">
              Además del libro principal, te llevás 7 BONOS EXCLUSIVOS:
            </h2>

            <ul className="space-y-3 mt-8" data-id="element-42">
              {bonuses.map((bono, index) => {
              const IconComponent = bono.icon;
              return <motion.li key={index} initial={{
                opacity: 0,
                x: 20
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.4,
                delay: index * 0.08
              }} className="flex items-center gap-3 text-lg text-gray-200 bg-white/10 p-4 rounded-xl border border-white/10 backdrop-blur-sm" data-id="element-43">
                    <IconComponent className={`${bono.color} flex-shrink-0`} size={22} data-id="element-44" />
                    <span data-id="element-45">{bono.text}</span>
                  </motion.li>;
            })}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}